import React, { Component } from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { constants, snowplow } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'

import ContinueCancellation from '../ContinueCancellation/ContinueCancellation'

import messages from './messages'
import s from './CancelSubscriptionModal.scss'


class CancelSubscriptionModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.CancelSubscription,
  }

  continueCancellation = () => {
    const { isFrequencyChangeable, isSkippable } = this.props

    this.close()

    // if there are nothing to show in the next modal `BeforeYouGoModal`
    // (with ChangeFrequencyButton and SkipAMonthButton) - then pass `BeforeYouGoModal` and show next one
    if (isFrequencyChangeable && isSkippable) {
      actions.models.modals.open(constants.modals.cancelSubscription.BeforeYouGo)
    }
    else {
      actions.models.modals.open(constants.modals.cancelSubscription.OneLastQuestion)
    }
  }

  close = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  trackCloseModal = (action) => {
    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'are you sure',
      action,
    }, false)
  }

  handleNeverMindClick = () => {
    this.trackCloseModal('never mind')
    this.close()
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  render() {
    const { name } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
        onClose={this.handleCloseModal}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
        <Button className={s.button} brand title={messages.neverMindButton} onClick={this.handleNeverMindClick} />
        <ContinueCancellation onClick={this.continueCancellation} />
      </Modal>
    )
  }
}


export default connect({
  isFrequencyChangeable: 'models.subscription.isFrequencyChangeable',
  isSkippable: 'models.subscription.isSkippable',
})(CancelSubscriptionModal)
